import './Modal.scss'

import clsx from 'clsx'

import { useAppDispatch, useAppSelector } from '../../app/hooks'
import { CUSTOMER_TYPES } from '../../consts'
import { postSaveCustomer } from '../../features/customer/customerSlice'
import { CheckIcon } from '../../GlobalComponents/_icons/Icons'
import styles from './CustomerTypeModal.module.scss'

interface ButtonProps {
    className?: string
    selected: boolean
    onClick(): void
    children: any
    testid?: any
}

const CustomerTypeModalButton = (props: ButtonProps) => {
    const { selected, onClick, children } = props
    let buttonClass = clsx([styles.button, 'a-button centered'])
    let selectedButtonClass = clsx([styles.selectedButton, 'a-button centered'])
    return (
        <div
            className={selected ? selectedButtonClass : buttonClass}
            onClick={() => !selected && onClick()}
            data-testid={props.testid}
        >
            {selected && <CheckIcon />}
            {children}
        </div>
    )
}
interface CustomerTypeModalProps {
    close(): void
}

export const CustomerTypeModal = (props: CustomerTypeModalProps) => {
    const { close } = props
    return (
        <div className={styles.customerTypeModal}>
            <div className={styles.customerTypeModalHeader}>
                <div className={styles.customerTypeTitle}>Select Customer Type</div>
                <div onClick={close} className={'a-i-close'} />
            </div>

            <div className={'a-divider'} />

            {Object.values(CUSTOMER_TYPES).map((value: any) => {
                return <CustomerTypeModalRow value={value} close={close} />
            })}
        </div>
    )
}
interface CustomerTypeModalRowProps {
    value: { typeId: number; title: string; typeText: string }
    close(): void
}

const CustomerTypeModalRow = (props: CustomerTypeModalRowProps) => {
    const { value, close } = props
    const customer = useAppSelector((state) => state.customer.currentCustomer!)

    const dispatch = useAppDispatch()
    const onSelect = async (typeId: number) => {
        dispatch(postSaveCustomer({ accountCode: customer.AccountCode, customerType: typeId }))
        close()
    }
    return (
        <div className={styles.customerTypeRow}>
            <div className={styles.customerTypeTitle}>{value.typeText}</div>
            <div>{value.title}</div>
            <CustomerTypeModalButton
                selected={customer.CustomerTypeName === value.typeText}
                onClick={
                    customer.CustomerTypeName !== value.typeText
                        ? () => onSelect(value.typeId)
                        : () => {}
                }
            >
                {customer.CustomerTypeName === value.typeText ? 'Selected' : 'Select'}
            </CustomerTypeModalButton>
        </div>
    )
}
